/* eslint-disable no-console */

export interface ILogger {
  error: (...msg: unknown[]) => void;
  info: (...msg: unknown[]) => void;
  log: (...msg: unknown[]) => void;
  warn: (...msg: unknown[]) => void;
}

const newLogger = (): ILogger => {
  const isDevelopment = import.meta.dev;
  const log = (...msg: unknown[]): void => {
    if (isDevelopment) {
      console.log(...msg);
    }
  };
  const info = (...msg: unknown[]): void => {
    if (isDevelopment) {
      console.info(...msg);
    }
  };
  const warn = (...msg: unknown[]): void => {
    if (isDevelopment) {
      console.warn(...msg);
    }
  };
  const error = (...msg: unknown[]): void => {
    console.error(...msg);
  };

  return { log, info, warn, error };
};

export const useLogger = (): ILogger => {
  return newLogger();
};
